import React from 'react';
import PropTypes, { instanceOf } from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import { withCookies, Cookies } from 'react-cookie';
import { Snackbar } from 'material-ui';
import withWidth, { SMALL } from 'material-ui/utils/withWidth';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import LoginPage from '../../common/LoginPage/LoginPage';
import DashboardPage from '../../common/DashboardPage/DashboardPage';
import EditApplicationPage from '../EditApplicationPage/EditApplicationPage';
import ApplicationPage from '../ApplicationPage/ApplicationPage';
import EditAdminPage from '../../admin/EditAdminPage/EditAdminPage';
import AdminPage from '../../admin/AdminPage/AdminPage';
import AddAdminPage from '../../admin/AddAdminPage/AddAdminPage';
import AddApplicationPage from '../AddApplicationPage/AddApplicationPage';
import ProfilePage from '../../common/ProfilePage/ProfilePage';
import EditProfilePage from '../../common/EditProfilePage/EditProfilePage';
import EditPasswordPage from '../../common/EditPasswordPage/EditPasswordPage';
import { resetError, resetInfo } from '../../../store/infos/actions';
import { getApps } from '../../../store/apps/actions';
import ThemeDefault from '../../../styles/theme-default';
import LeftDrawer from '../../../components/common/LeftDrawer/LeftDrawer';
import Header from '../../../components/common/Header/Header';
import AdminService, { ADMIN, SUPER_ADMIN } from '../../../services/admin';
import OpenExploreListPage from '../../openexplore/OpenExploreListPage/OpenExploreListPage';
import OpenExploreMapPage from '../../openexplore/OpenExploreMapPage/OpenExploreMapPage';
import '../../../resources/css/App.css';
import { closeDrawer, openDrawer } from '../../../store/ui/actions';
import PointPage from '../../openexplore/PointPage/PointPage';
import EditPointPage from '../../openexplore/EditPointPage/EditPointPage';
import AddPointPage from '../../openexplore/AddPointPage/AddPointPage';
import TrailPage from '../../openexplore/TrailPage/TrailPage';
import AddTrailPage from '../../openexplore/AddTrailPage/AddTrailPage';
import EditTrailPage from '../../openexplore/EditTrailPage/EditTrailPage';
import SettingsPage from '../../common/SettingsPage/SettingsPage';
import AddTypePage from '../../types/AddTypePage/AddTypePage';
import EditTypePage from '../../types/EditTypePage/EditTypePage';
import TypePage from '../../types/TypePage/TypePage';
import OpenExplore from '../../../components/openexplore/OpenExplore/OpenExplore';
import AddCustomFieldPage from '../../customfield/AddCustomFieldPage/AddCustomFieldPage';
import EditCustomFieldPage from '../../customfield/EditCustomFieldPage/EditCustomFieldPage';
import CustomFieldService from '../../../services/customfield';
import CommentsPage from '../../comments/CommentsPage/CommentsPage';
import PushPage from '../../push/PushPage/PushPage';
import EditMediaPage from '../../openexplore/EditMediaPage/EditMediaPage';
import AddPushGroupPage from '../../push/AddPushGroupPage/AddPushGroupPage';
import AddPushSoundPage from '../../push/AddPushSoundPage/AddPushSoundPage';
import AddMediaTypePage from '../../mediatypes/AddMediaTypePage/AddMediaTypePage';
import EditMediaTypePage from '../../mediatypes/EditMediaTypePage/EditMediaTypePage';
import MediaTypePage from '../../mediatypes/MediaTypePage/MediaTypePage';
import MimeMediaListPage from '../../openexplore/MimeMediaListPage/MimeMediaListPage';
import {
    HOMEPAGE,
    LOGIN,
    DASHBOARD,
    SETTING_PAGE,
    PUSH_PAGE,
    ADD_TYPE_PAGE,
    COMMENTS_PAGE,
    EDIT_TYPE_PAGE,
    TYPE_PAGE,
    EDIT_MEDIA_TYPE_PAGE,
    MEDIA_TYPE_PAGE,
    ADD_TRAIL_PAGE,
    EDIT_TRAIL_PAGE,
    ADD_POINT_PAGE,
    EDIT_POINT_PAGE,
    EDIT_OPENEXPLORE_MEDIA_PAGE,
    ADD_MEDIA_TYPE_PAGE,
    MIME_MEDIA_LIST_PAGE,
    ADD_CF_TRAIL_PAGE,
    ADD_CF_POINT_PAGE,
    EDIT_CF_PAGE,
    ADD_PUSH_GROUP_PAGE,
    ADD_PUSH_SOUND_PAGE,
    ADD_APPLICATION_PAGE,
    EDIT_APPLICATION_PAGE,
    ADD_ADMIN_PAGE,
    EDIT_ADMIN_PAGE,
    ADMIN_PAGE,
    APPLICATION_PAGE,
    PROFILE_PAGE,
    EDIT_PROFILE_PAGE,
    EDIT_PASSWORD_PAGE,
    TRAIL_PAGE,
    POINT_PAGE,
    OPENEXPLORE_PAGE,
    OPENEXPLORE_MAP_PAGE,
    OPENEXPLORE_LIST_PAGE,
    REPORTS_PAGE,
    REPORTS_MAP_PAGE,
    REPORTS_LIST_PAGE,
    REPORT_PAGE,
    ADD_REPORTSUBJECT_PAGE,
    REPORTSUBJECT_PAGE,
    EDIT_REPORTSUBJECT_PAGE,
    NEWS_LIST_PAGE,
    NEWS_PAGE,
    ADD_NEWS_PAGE,
    EDIT_NEWS_PAGE,
    NEWS_MIME_MEDIA_LIST_PAGE,
    EDIT_NEWS_MEDIA_PAGE,
    ADD_CF_NEWS_PAGE,
    PAGE_PAGE,
    PAGE_MIME_MEDIA_LIST_PAGE,
    EDIT_PAGE_PAGE,
    ADD_PAGE_PAGE,
    PAGE_LIST_PAGE,
    EDIT_PAGE_MEDIA_PAGE,
    ROAD_BOOKS_PAGE,
    ROAD_BOOK_CONFIGURATION_PAGE,
    ADD_ROAD_BOOK_CONFIGURATION_PAGE,
    EDIT_ROAD_BOOK_CONFIGURATION_PAGE,
    GAMIFICATIONS_PAGE,
    ACHIEVEMENT_PAGE,
    EDIT_ACHIEVEMENT_PAGE,
    ADD_ACHIEVEMENT_PAGE,
    QUIZZES_PAGE,
    QUIZ_PAGE,
    ADD_QUIZ_PAGE,
    EDIT_QUIZ_PAGE,
    ADD_ACCESS_TOKEN_PAGE, ADD_CF_ACHIEVEMENT_PAGE,
} from '../../../constants/routes';
import Reports from '../../../components/report/Reports/Reports';
import ReportsListPage from '../../../containers/reports/ReportsListPage';
import ReportsMapPage from '../../../containers/reports/ReportsMapPage';
import ReportPage from '../../reports/ReportPage/ReportPage';
import AddReportSubjectPage from '../../reportsubjects/AddReportSubjectPage/AddReportSubjectPage';
import EditReportSubjectPage
    from '../../reportsubjects/EditReportSubjectPage/EditReportSubjectPage';
import ReportSubjectPage from '../../reportsubjects/ReportSubjectPage/ReportSubjectPage';
import NewsListPage from '../../news/NewsListPage';
import AddNewsPage from '../../news/AddNewsPage';
import NewsPage from '../../news/NewsPage';
import EditNewsPage from '../../news/EditNewsPage';
import NewsMimeMediaListPage from '../../news/NewsMimeMediaListPage';
import PageMimeMediaListPage from '../../page/PageMimeMediaListPage';
import EditNewsMediaPage from '../../news/EditNewsMediaPage';
import PagePage from '../../page/PagePage';
import PageListPage from '../../page/PageListPage';
import EditPagePage from '../../page/EditPagePage';
import AddPagePage from '../../page/AddPagePage';
import EditPageMediaPage from '../../page/EditPageMediaPage';
import RoadBookListPage from '../../roadbook/RoadBookListPage';
import RoadBookAvailablePage from '../../roadbook/RoadBookAvailablePage';
import AddRoadBookAvailablePage from '../../roadbook/AddRoadBookAvailablePage';
import EditRoadBookAvailablePage from '../../roadbook/EditRoadBookAvailablePage';
import GamificationPage from '../../gamification/GamificationPage/GamificationPage';
import AchievementPage from '../../gamification/AchievementPage/AchievementPage';
import AddAchievementPage from '../../gamification/AddAchievementPage/AddAchievementPage';
import EditAchievementPage from '../../gamification/EditAchievementPage/EditAchievementPage';
import QuizListPage from '../../quiz/QuizListPage/QuizListPage';
import QuizPage from '../../quiz/QuizPage/QuizPage';
import EditQuizPage from '../../quiz/EditQuizPage/EditQuizPage';
import AddQuizPage from '../../quiz/AddQuizPage/AddQuizPage';
import AddAccessTokenPage from '../../accessToken/AddAccessTokenPage';

export class App extends React.Component {

    static propTypes = {
        cookies: instanceOf(Cookies),
        children: PropTypes.element,
        width: PropTypes.number,
    };

    componentWillMount() {
        if (!this.props.authenticated) {
            this.props.history.push(LOGIN);
        } else {
            this.props.getApps();
        }

        if (this.props.width === SMALL) {
            this.props.closeDrawer();
        }
    }

    componentWillUpdate(nextProps) {
        if (!nextProps.authenticated && nextProps.location.pathname !== LOGIN) {
            nextProps.history.push(LOGIN);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.authenticated && nextProps.authenticated) {
            this.props.getApps();
        }

        if (this.props.width !== nextProps.width) {
            if (nextProps.width !== SMALL) {
                this.props.openDrawer();
            } else {
                this.props.closeDrawer();
            }
        }

        if (nextProps.width === SMALL && this.props.match !== nextProps.match) {
            this.props.closeDrawer();
        }
    }

    // Actions

    handleErrorSnackbarClose = () => {
        this.props.resetError();
    };

    handleInfoSnackbarClose = () => {
        this.props.resetInfo();
    };

    handleChangeRequestNavDrawer = () => {
        if (this.props.navDrawerOpen) {
            this.props.closeDrawer();
        } else {
            this.props.openDrawer();
        }
    };

    // Render

    renderLogin() {
        const styles = {
            header: {
                paddingLeft: 0,
            },
            container: {
                marginTop: '57px',
            },
        };

        return (
            <MuiThemeProvider muiTheme={ThemeDefault}>
                <div>
                    <Header styles={styles.header} presentationMode={true} />

                    <div style={styles.container}>
                        <LoginPage />
                    </div>
                </div>
            </MuiThemeProvider>
        );
    }

    renderDashboard() {
        let { navDrawerOpen, paddingLeftDrawerOpen } = this.props;

        const styles = {
            header: {
                paddingLeft: navDrawerOpen ? paddingLeftDrawerOpen : 0,
            },
            container: {
                paddingLeft: navDrawerOpen && this.props.width !== SMALL ? paddingLeftDrawerOpen : 0,
            },
        };

        let adminRoutes;
        if (AdminService.isAuthorized(ADMIN, this.props.user)) {
            adminRoutes = (
                <div>
                    <Route exact path={SETTING_PAGE} component={SettingsPage} />

                    <Route exact path={COMMENTS_PAGE} component={CommentsPage} />
                    <Route exact path={PUSH_PAGE} component={PushPage} />

                    <Route exact path={ADD_TYPE_PAGE} component={AddTypePage} />
                    <Route exact path={EDIT_TYPE_PAGE} component={EditTypePage} />
                    <Route exact path={TYPE_PAGE} component={TypePage} />

                    <Route exact path={ADD_REPORTSUBJECT_PAGE} component={AddReportSubjectPage} />
                    <Route exact path={EDIT_REPORTSUBJECT_PAGE} component={EditReportSubjectPage} />
                    <Route exact path={REPORTSUBJECT_PAGE} component={ReportSubjectPage} />

                    <Route exact path={ADD_MEDIA_TYPE_PAGE} component={AddMediaTypePage} />
                    <Route exact path={EDIT_MEDIA_TYPE_PAGE} component={EditMediaTypePage} />
                    <Route exact path={MEDIA_TYPE_PAGE} component={MediaTypePage} />

                    <Route exact path={EDIT_POINT_PAGE} component={EditPointPage} />
                    <Route exact path={ADD_POINT_PAGE} component={AddPointPage} />

                    <Route exact path={EDIT_TRAIL_PAGE} component={EditTrailPage} />
                    <Route exact path={ADD_TRAIL_PAGE} component={AddTrailPage} />

                    <Route exact path={ADD_NEWS_PAGE} component={AddNewsPage} />
                    <Route exact path={EDIT_NEWS_PAGE} component={EditNewsPage} />
                    <Route exact path={NEWS_MIME_MEDIA_LIST_PAGE}
                           component={NewsMimeMediaListPage} />
                    <Route exact path={EDIT_NEWS_MEDIA_PAGE} component={EditNewsMediaPage} />

                    <Route exact path={ADD_PAGE_PAGE} component={AddPagePage} />
                    <Route exact path={EDIT_PAGE_PAGE} component={EditPagePage} />
                    <Route exact path={PAGE_PAGE} component={PagePage} />
                    <Route exact path={PAGE_MIME_MEDIA_LIST_PAGE}
                           component={PageMimeMediaListPage} />
                    <Route exact path={PAGE_LIST_PAGE} component={PageListPage} />
                    <Route exact path={EDIT_PAGE_MEDIA_PAGE} component={EditPageMediaPage} />

                    <Route exact path={ADD_ACHIEVEMENT_PAGE} component={AddAchievementPage} />
                    <Route exact path={ACHIEVEMENT_PAGE} component={AchievementPage} />
                    <Route exact path={EDIT_ACHIEVEMENT_PAGE} component={EditAchievementPage} />
                    <Route exact path={GAMIFICATIONS_PAGE} component={GamificationPage} />

                    <Route exact path={QUIZZES_PAGE} component={QuizListPage} />
                    <Route exact path={ADD_QUIZ_PAGE} component={AddQuizPage} />
                    <Route exact path={QUIZ_PAGE} component={QuizPage} />
                    <Route exact path={EDIT_QUIZ_PAGE} component={EditQuizPage} />

                    <Route exact path={ADD_ACCESS_TOKEN_PAGE} component={AddAccessTokenPage} />

                    {/* Entity type dependent */}
                    <Route exact path={EDIT_OPENEXPLORE_MEDIA_PAGE} component={EditMediaPage} />
                    <Route exact path={MIME_MEDIA_LIST_PAGE} component={MimeMediaListPage} />
                    <Route exact path={ROAD_BOOKS_PAGE} component={RoadBookListPage} />
                    <Route exact path={ROAD_BOOK_CONFIGURATION_PAGE} component={RoadBookAvailablePage} />
                    <Route exact path={ADD_ROAD_BOOK_CONFIGURATION_PAGE} component={AddRoadBookAvailablePage} />
                    <Route exact path={EDIT_ROAD_BOOK_CONFIGURATION_PAGE} component={EditRoadBookAvailablePage} />
                </div>
            );
        }

        let superAdminRoutes;
        if (AdminService.isAuthorized(SUPER_ADMIN, this.props.user)) {
            superAdminRoutes = (
                <div>
                    <Route exact path={ADD_CF_TRAIL_PAGE} render={routeProps => {
                        return <AddCustomFieldPage {...routeProps}
                                                   entityName={CustomFieldService.OPEN_EXPLORE_TRAIL}
                                                   entityDisplayName="Trail" />;
                    }} />
                    <Route exact path={ADD_CF_POINT_PAGE} render={routeProps => {
                        return <AddCustomFieldPage {...routeProps}
                                                   entityName={CustomFieldService.OPEN_EXPLORE_POINT}
                                                   entityDisplayName="Point" />;
                    }} />
                    <Route exact path={ADD_CF_NEWS_PAGE} render={routeProps => {
                        return <AddCustomFieldPage {...routeProps}
                                                   entityName={CustomFieldService.NEWS}
                                                   entityDisplayName="News" />;
                    }} />
                    <Route exact path={ADD_CF_ACHIEVEMENT_PAGE} render={routeProps => {
                        return <AddCustomFieldPage {...routeProps}
                                                   entityName={CustomFieldService.ACHIEVEMENT}
                                                   entityDisplayName="Achievement" />;
                    }} />
                    <Route exact path={EDIT_CF_PAGE} component={EditCustomFieldPage} />
                    <Route exact path={ADD_PUSH_GROUP_PAGE} component={AddPushGroupPage} />
                    <Route exact path={ADD_PUSH_SOUND_PAGE} component={AddPushSoundPage} />
                    <Route exact path={ADD_APPLICATION_PAGE} component={AddApplicationPage} />
                    <Route exact path={EDIT_APPLICATION_PAGE} component={EditApplicationPage} />
                    <Route exact path={EDIT_ADMIN_PAGE} component={EditAdminPage} />
                    <Route exact path={ADD_ADMIN_PAGE} component={AddAdminPage} />
                </div>
            );
        }

        return (
            <MuiThemeProvider muiTheme={ThemeDefault}>
                <div>
                    <Header styles={styles.header}
                            handleChangeRequestNavDrawer={this.handleChangeRequestNavDrawer} />

                    <LeftDrawer navDrawerOpen={navDrawerOpen} user={this.props.user} />
                    {!this.props.authPending && <div>
                        <div id="container" style={styles.container}>

                            <Snackbar
                                open={this.props.error !== null && this.props.error !== ''}
                                message={this.props.error || ''}
                                action="Close"
                                onActionTouchTap={this.handleErrorSnackbarClose}
                                onRequestClose={this.handleErrorSnackbarClose}
                                onActionClick={this.handleErrorSnackbarClose}
                            />

                            <Snackbar
                                open={this.props.info !== null && this.props.info !== ''}
                                message={this.props.info || ''}
                                action="Ok"
                                autoHideDuration={4000}
                                onActionTouchTap={this.handleInfoSnackbarClose}
                                onRequestClose={this.handleInfoSnackbarClose}
                                onActionClick={this.handleInfoSnackbarClose}
                            />

                            {/* Default route */}
                            <Route exact path={HOMEPAGE} component={DashboardPage} />

                            {/* Application */}
                            <Route exact path={APPLICATION_PAGE} component={ApplicationPage} />

                            {/* Users */}
                            <Route exact path={ADMIN_PAGE} component={AdminPage} />

                            {/* Menu */}
                            <Route exact path={DASHBOARD} component={DashboardPage} />
                            <Route exact path={PROFILE_PAGE} component={ProfilePage} />
                            <Route exact path={EDIT_PROFILE_PAGE} component={EditProfilePage} />
                            <Route exact path={EDIT_PASSWORD_PAGE} component={EditPasswordPage} />
                            <Route exact path={LOGIN} component={LoginPage} />

                            {/* Open Explore */}
                            <Route exact path={POINT_PAGE} component={PointPage} />
                            <Route exact path={TRAIL_PAGE} component={TrailPage} />

                            {/* Report */}
                            <Route exact path={REPORTS_LIST_PAGE} component={ReportsListPage} />
                            <Route exact path={REPORT_PAGE} component={ReportPage} />

                            {/* News */}
                            <Route exact path={NEWS_LIST_PAGE} component={NewsListPage} />
                            <Route exact path={NEWS_PAGE} component={NewsPage} />

                            {/* Admin only routes */}
                            {adminRoutes}

                            {/* Super Admin only routes */}
                            {superAdminRoutes}
                        </div>

                        <div id="flat-container" style={styles.container}>
                            {/* Open Explore */}
                            <Route exact path={OPENEXPLORE_PAGE} component={OpenExplore} />
                            <Route exact path={OPENEXPLORE_MAP_PAGE}
                                   component={OpenExploreMapPage} />
                            <Route exact path={OPENEXPLORE_LIST_PAGE}
                                   component={OpenExploreListPage} />
                        </div>

                        <div id="flat-container" style={styles.container}>
                            {/* Report */}
                            <Route exact path={REPORTS_PAGE} component={Reports} />
                            <Route exact path={REPORTS_MAP_PAGE} component={ReportsMapPage} />
                        </div>
                    </div>}
                </div>
            </MuiThemeProvider>
        );
    }

    render() {
        if (this.props.authenticated) {
            return this.renderDashboard();
        } else {
            return this.renderLogin();
        }
    }
}

function mapStateToProps(state) {
    return {
        paddingLeftDrawerOpen: state.ui.leftPadding,
        navDrawerOpen: state.ui.drawerOpened,
        authenticated: state.auth.authenticated,
        user: state.auth.content,
        authPending: state.auth.pending,
        error: state.info.error,
        info: state.info.info,
    };
}

export default connect(mapStateToProps, {
    getApps,
    resetError,
    resetInfo,
    openDrawer,
    closeDrawer,
})(withRouter(withCookies(withWidth()(App))));





// WEBPACK FOOTER //
// src/containers/application/App/App.js